import { Prebid } from "../types";
import { websiteID } from "../../settings";

const getKeyValuePairs = () => [
  { key: "bt_mwr", val: "true" },
  { key: "rl_wid", val: websiteID },
];

export const appendKVPToAdRequest = () => {
  appendKVPToAdPrebid();

  // Typically, Prebid handles adding KVPs to GAM when adserverTargeting is configured.
  // However, we've encountered scenarios where some ad units on a page are exclusive to GAM,
  // making it difficult to manually apply KVPs only in those situations.
  // When adblock is disabled, we have limited control over when slots are created or when refresh is called,
  // among other variables. Therefore, we set the KVP globally in GAM to ensure it functions correctly in all cases.
  appendKVPToAdGoogleTag();
};

/* Prebid */

const appendKVPToAdPrebid = () => {
  const prebidInstances = getPrebidInstances();
  if (prebidInstances.length === 0) return false;

  prebidInstances.forEach((pbjs) => {
    appendKVPToAdPrebidInstance(pbjs);
  });
  return true;
};

export const getPrebidInstances = () => {
  if (!window._pbjsGlobals) return [];
  return window._pbjsGlobals
    .map((pbjsKey) => window[pbjsKey])
    .filter(Boolean)
    .map(initializeBidderSettings);
};

const appendKVPToAdPrebidInstance = (pbjs: Prebid) => {
  const kvSet = getKeyValuePairs();
  kvSet.forEach((kvp) => {
    pbjs?.bidderSettings?.standard?.adserverTargeting?.push(
      getPrebidKeyValue(kvp.key, kvp.val),
    );
  });
};

const initializeBidderSettings = (pbjs: Prebid) => {
  pbjs.bidderSettings = {
    ...pbjs.bidderSettings,
    standard: {
      ...pbjs.bidderSettings?.standard,
      adserverTargeting: [
        ...(pbjs.bidderSettings?.standard?.adserverTargeting || []),
      ],
    },
  };
  return pbjs;
};

const getPrebidKeyValue = (key: string, val: string) => ({
  key: key,
  val: () => val,
});

/* Google Tag */

const appendKVPToAdGoogleTag = () => {
  window.googletag?.cmd?.push(function () {
    const kvSet = getKeyValuePairs();
    kvSet.forEach((kvp) => {
      window.googletag.pubads().setTargeting(kvp.key, kvp.val);
    });
  });
};
